import { useState } from 'react';
import { cn } from '@divlab/divanui';
import { IconAttention, IconChevronRight } from '@divlab/divanui/icons';

import useTranslation from '@Queries/useTranslation';
import useOnClickOutside from '@Hooks/useOnClickOutside';
import styles from './AdditionalPeriod.module.css';

import type { FC, HTMLAttributes } from 'react';

export type AdditionalPeriodData = {
  icon: 'attention' | 'chevron';
  onChevronClick?(): void;
};

type AdditionalPeriodProps = HTMLAttributes<HTMLDivElement> & AdditionalPeriodData;

const AdditionalPeriod: FC<AdditionalPeriodProps> = (props) => {
  const { className, icon, onChevronClick, ...restProps } = props;
  const { t } = useTranslation();
  const [showedTooltip, setShowTooltip] = useState(false);

  const text = t('ui.yandex-split.additional-period.text');
  const period = t('ui.yandex-split.additional-period.period');
  const tooltip = t('ui.yandex-split.additional-period.tooltip');

  const handleChevronClick = () => onChevronClick();
  const toggleTooltip = () => setShowTooltip((prev) => !prev);
  const hideTooltip = () => setShowTooltip(false);

  const blockRef = useOnClickOutside<HTMLDivElement>(hideTooltip);

  return (
    <div className={cn(styles.block, className)} {...restProps}>
      <div>
        <span className={styles.bold}>{text}</span> {period}
      </div>

      {icon === 'attention' && (
        <div className={styles.icon} ref={blockRef} onClick={toggleTooltip}>
          <IconAttention />
        </div>
      )}

      {icon === 'chevron' && onChevronClick && (
        <IconChevronRight className={styles.icon} onClick={handleChevronClick} />
      )}

      {showedTooltip && <div className={styles.tooltip}>{tooltip}</div>}
    </div>
  );
};

export default AdditionalPeriod;
